import type { ReactNode } from 'react'
import logo from '../../../assets/images/logo.svg'
import logoLight from '../../../assets/images/logoLight.svg'
import './HomeBlock.css'

interface HomeBlockProps {
  title: string
  /** Подпись под заголовком — в макете она есть у курсов. */
  subtitle?: string
  /** Тема блока: по макету у курсов цветная подложка, у недавних светлая. */
  tone?: 'plain' | 'accent' | 'muted'
  /** Логотип рядом с заголовком — в макете он стоит у «Библиотеки» и «Курсов». */
  withLogo?: boolean
  children: ReactNode
}

/**
 * Блок главной: заголовок и горизонтальная лента карточек.
 *
 * Один компонент на все блоки — в макете они отличаются только фоном и
 * содержимым, а структура и отступы общие.
 */
const HomeBlock = ({
  title,
  subtitle,
  tone = 'plain',
  withLogo = false,
  children,
}: HomeBlockProps) => (
  <section className={`home-block home-block--${tone}`}>
    <h2 className="home-block__title">
      {title}
      {withLogo && (
        // На цветной подложке логотип светлый, на белой — обычный.
        <img
          className="home-block__logo"
          src={tone === 'accent' ? logoLight : logo}
          alt="Pauline Cake"
        />
      )}
    </h2>
    {subtitle && <p className="home-block__subtitle">{subtitle}</p>}
    <div className="home-block__scroller">{children}</div>
  </section>
)

export default HomeBlock
